module.exports = __webpack_public_path__ + "img/ic_name.610528e3.png";